// Base App urls
export const baseUrls = {
  // Pages accessible whether logged in or logged out
  root: "/",
  error: "/error",
  emailverification: "/emailverification",

  // Legal pages - accessible whether logged in or logged out
  cookiePolicy: "/cookie-policy",
  privacy: "/privacy",
  termsOfService: "/termsOfService",
  termsOfServiceForPremiumContent: "/neonpremiumcontenttermsofservice",
  termsOfUse: "/termsOfUse",

  // Pages accessible only when logged out
  // (otherwise we redirect to dashboard)
  callback: "/callback", // Auth0 callback has no UI and just redirects to root
  forgot: "/forgot",
  loggedOut: "/loggedout", // No UI, just redirects to root
  login: "/login",
  loginMfa: "/loginMfa",
  oneTrustLogin: "/onetrustlogin",
  passwordUpdated: "/password-updated",
  signup: "/signup",
  splashScreen: "/signin",
  verifyAccount: "/verify-account",

  // Accessible only when logged in
  complete: "/complete",
  dashboard: "/dashboard",
  manageAccount: "/manage-account",
  neonRiskDownload: "/neon-risk-download",
  neonTraderDownload: "/neon-trader-download",

  // Unused (redirects to dashboard)
  account: "/account",
};
